// @ts-nocheck
import * as Types from '../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc } from '../../../../../fragments/commonFragments.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ScopeTemplatesApplyStepMetadataQueryVariables = Types.Exact<{
  input: Types.MilestoneTasksForTemplatesInput;
}>;


export type ScopeTemplatesApplyStepMetadataQuery = { __typename?: 'Query', milestoneTasksForTemplates: Array<{ __typename?: 'ScheduleTask', id: string, name: string }> };

export type ScopeTemplatesApplyStepQueryVariables = Types.Exact<{
  input: Types.ProjectsToUpdateByTemplatesInput;
}>;


export type ScopeTemplatesApplyStepQuery = { __typename?: 'Query', projectsToUpdateByTemplates: { __typename?: 'ProjectsToUpdateByTemplatesResult', projectsToUpdate: Array<{ __typename?: 'ProjectToUpdate', project:
        | { __typename?: 'StandaloneProject', id: string, name: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, constructionStartDate?: Types.Scalars['Date']['input'] | null | undefined } | null | undefined }
        | { __typename?: 'Region', id: string, name: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, constructionStartDate?: Types.Scalars['Date']['input'] | null | undefined } | null | undefined }
        | { __typename?: 'Market', id: string, name: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, constructionStartDate?: Types.Scalars['Date']['input'] | null | undefined } | null | undefined }
        | { __typename?: 'Community', id: string, name: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, constructionStartDate?: Types.Scalars['Date']['input'] | null | undefined } | null | undefined }
        | { __typename?: 'Subdivision', id: string, name: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, constructionStartDate?: Types.Scalars['Date']['input'] | null | undefined } | null | undefined }
        | { __typename?: 'Lot', id: string, name: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, constructionStartDate?: Types.Scalars['Date']['input'] | null | undefined } | null | undefined }
        | { __typename?: 'Structure', id: string, name: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, constructionStartDate?: Types.Scalars['Date']['input'] | null | undefined } | null | undefined }
        | { __typename?: 'Unit', id: string, name: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, constructionStartDate?: Types.Scalars['Date']['input'] | null | undefined } | null | undefined }
      , proposedTemplate: { __typename?: 'ItemTemplate', id: string, displayName: string, version: string, status: Types.ItemTemplateStatus } }> } };

export type ScopeTemplateApplyStepApplyToProjectMutationVariables = Types.Exact<{
  input: Types.ApplyProjectReadyPlanConfigsInput;
}>;


export type ScopeTemplateApplyStepApplyToProjectMutation = { __typename?: 'Mutation', applyProjectReadyPlanConfigs: { __typename?: 'ApplyProjectReadyPlanConfigsResult', projectReadyPlanConfigs: Array<{ __typename?: 'ProjectReadyPlanConfig', id: string, project:
        | { __typename?: 'StandaloneProject', id: string, name: string }
        | { __typename?: 'Region', id: string, name: string }
        | { __typename?: 'Market', id: string, name: string }
        | { __typename?: 'Community', id: string, name: string }
        | { __typename?: 'Subdivision', id: string, name: string }
        | { __typename?: 'Lot', id: string, name: string }
        | { __typename?: 'Structure', id: string, name: string }
        | { __typename?: 'Unit', id: string, name: string }
       }> } };

export type ApplyStep_ProjectToUpdateFragment = { __typename?: 'ProjectToUpdate', project:
    | { __typename?: 'StandaloneProject', id: string, name: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, constructionStartDate?: Types.Scalars['Date']['input'] | null | undefined } | null | undefined }
    | { __typename?: 'Region', id: string, name: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, constructionStartDate?: Types.Scalars['Date']['input'] | null | undefined } | null | undefined }
    | { __typename?: 'Market', id: string, name: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, constructionStartDate?: Types.Scalars['Date']['input'] | null | undefined } | null | undefined }
    | { __typename?: 'Community', id: string, name: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, constructionStartDate?: Types.Scalars['Date']['input'] | null | undefined } | null | undefined }
    | { __typename?: 'Subdivision', id: string, name: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, constructionStartDate?: Types.Scalars['Date']['input'] | null | undefined } | null | undefined }
    | { __typename?: 'Lot', id: string, name: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, constructionStartDate?: Types.Scalars['Date']['input'] | null | undefined } | null | undefined }
    | { __typename?: 'Structure', id: string, name: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, constructionStartDate?: Types.Scalars['Date']['input'] | null | undefined } | null | undefined }
    | { __typename?: 'Unit', id: string, name: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, constructionStartDate?: Types.Scalars['Date']['input'] | null | undefined } | null | undefined }
  , proposedTemplate: { __typename?: 'ItemTemplate', id: string, displayName: string, version: string, status: Types.ItemTemplateStatus } };

export const ApplyStep_ProjectToUpdateFragmentDoc = gql`
    fragment ApplyStep_ProjectToUpdate on ProjectToUpdate {
  project {
    id
    name
    readyPlanConfig {
      id
      constructionStartDate
    }
  }
  proposedTemplate {
    id
    displayName
    version
    status
  }
}
    `;
export const ScopeTemplatesApplyStepMetadataDocument = gql`
    query ScopeTemplatesApplyStepMetadata($input: MilestoneTasksForTemplatesInput!) {
  milestoneTasksForTemplates(input: $input) {
    id
    name
  }
}
    `;

/**
 * __useScopeTemplatesApplyStepMetadataQuery__
 *
 * To run a query within a React component, call `useScopeTemplatesApplyStepMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useScopeTemplatesApplyStepMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScopeTemplatesApplyStepMetadataQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useScopeTemplatesApplyStepMetadataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ScopeTemplatesApplyStepMetadataQuery, ScopeTemplatesApplyStepMetadataQueryVariables> & ({ variables: ScopeTemplatesApplyStepMetadataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ScopeTemplatesApplyStepMetadataQuery, ScopeTemplatesApplyStepMetadataQueryVariables>(ScopeTemplatesApplyStepMetadataDocument, options);
      }
export function useScopeTemplatesApplyStepMetadataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ScopeTemplatesApplyStepMetadataQuery, ScopeTemplatesApplyStepMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ScopeTemplatesApplyStepMetadataQuery, ScopeTemplatesApplyStepMetadataQueryVariables>(ScopeTemplatesApplyStepMetadataDocument, options);
        }
// @ts-ignore
export function useScopeTemplatesApplyStepMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ScopeTemplatesApplyStepMetadataQuery, ScopeTemplatesApplyStepMetadataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ScopeTemplatesApplyStepMetadataQuery, ScopeTemplatesApplyStepMetadataQueryVariables>;
export function useScopeTemplatesApplyStepMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ScopeTemplatesApplyStepMetadataQuery, ScopeTemplatesApplyStepMetadataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ScopeTemplatesApplyStepMetadataQuery | undefined, ScopeTemplatesApplyStepMetadataQueryVariables>;
export function useScopeTemplatesApplyStepMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ScopeTemplatesApplyStepMetadataQuery, ScopeTemplatesApplyStepMetadataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ScopeTemplatesApplyStepMetadataQuery, ScopeTemplatesApplyStepMetadataQueryVariables>(ScopeTemplatesApplyStepMetadataDocument, options);
        }
export type ScopeTemplatesApplyStepMetadataQueryHookResult = ReturnType<typeof useScopeTemplatesApplyStepMetadataQuery>;
export type ScopeTemplatesApplyStepMetadataLazyQueryHookResult = ReturnType<typeof useScopeTemplatesApplyStepMetadataLazyQuery>;
export type ScopeTemplatesApplyStepMetadataSuspenseQueryHookResult = ReturnType<typeof useScopeTemplatesApplyStepMetadataSuspenseQuery>;
export type ScopeTemplatesApplyStepMetadataQueryResult = ApolloReactCommon.QueryResult<ScopeTemplatesApplyStepMetadataQuery, ScopeTemplatesApplyStepMetadataQueryVariables>;
export const ScopeTemplatesApplyStepDocument = gql`
    query ScopeTemplatesApplyStep($input: ProjectsToUpdateByTemplatesInput!) {
  projectsToUpdateByTemplates(input: $input) {
    projectsToUpdate {
      ...ApplyStep_ProjectToUpdate
    }
  }
}
    ${ApplyStep_ProjectToUpdateFragmentDoc}`;

/**
 * __useScopeTemplatesApplyStepQuery__
 *
 * To run a query within a React component, call `useScopeTemplatesApplyStepQuery` and pass it any options that fit your needs.
 * When your component renders, `useScopeTemplatesApplyStepQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScopeTemplatesApplyStepQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useScopeTemplatesApplyStepQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ScopeTemplatesApplyStepQuery, ScopeTemplatesApplyStepQueryVariables> & ({ variables: ScopeTemplatesApplyStepQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ScopeTemplatesApplyStepQuery, ScopeTemplatesApplyStepQueryVariables>(ScopeTemplatesApplyStepDocument, options);
      }
export function useScopeTemplatesApplyStepLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ScopeTemplatesApplyStepQuery, ScopeTemplatesApplyStepQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ScopeTemplatesApplyStepQuery, ScopeTemplatesApplyStepQueryVariables>(ScopeTemplatesApplyStepDocument, options);
        }
// @ts-ignore
export function useScopeTemplatesApplyStepSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ScopeTemplatesApplyStepQuery, ScopeTemplatesApplyStepQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ScopeTemplatesApplyStepQuery, ScopeTemplatesApplyStepQueryVariables>;
export function useScopeTemplatesApplyStepSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ScopeTemplatesApplyStepQuery, ScopeTemplatesApplyStepQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ScopeTemplatesApplyStepQuery | undefined, ScopeTemplatesApplyStepQueryVariables>;
export function useScopeTemplatesApplyStepSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ScopeTemplatesApplyStepQuery, ScopeTemplatesApplyStepQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ScopeTemplatesApplyStepQuery, ScopeTemplatesApplyStepQueryVariables>(ScopeTemplatesApplyStepDocument, options);
        }
export type ScopeTemplatesApplyStepQueryHookResult = ReturnType<typeof useScopeTemplatesApplyStepQuery>;
export type ScopeTemplatesApplyStepLazyQueryHookResult = ReturnType<typeof useScopeTemplatesApplyStepLazyQuery>;
export type ScopeTemplatesApplyStepSuspenseQueryHookResult = ReturnType<typeof useScopeTemplatesApplyStepSuspenseQuery>;
export type ScopeTemplatesApplyStepQueryResult = ApolloReactCommon.QueryResult<ScopeTemplatesApplyStepQuery, ScopeTemplatesApplyStepQueryVariables>;
export const ScopeTemplateApplyStepApplyToProjectDocument = gql`
    mutation ScopeTemplateApplyStepApplyToProject($input: ApplyProjectReadyPlanConfigsInput!) {
  applyProjectReadyPlanConfigs(input: $input) {
    projectReadyPlanConfigs {
      id
      project {
        ...Named
      }
    }
  }
}
    ${NamedFragmentDoc}`;

/**
 * __useScopeTemplateApplyStepApplyToProjectMutation__
 *
 * To run a mutation, you first call `useScopeTemplateApplyStepApplyToProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScopeTemplateApplyStepApplyToProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scopeTemplateApplyStepApplyToProjectMutation, { data, loading, error }] = useScopeTemplateApplyStepApplyToProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useScopeTemplateApplyStepApplyToProjectMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ScopeTemplateApplyStepApplyToProjectMutation, ScopeTemplateApplyStepApplyToProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ScopeTemplateApplyStepApplyToProjectMutation, ScopeTemplateApplyStepApplyToProjectMutationVariables>(ScopeTemplateApplyStepApplyToProjectDocument, options);
      }
export type ScopeTemplateApplyStepApplyToProjectMutationHookResult = ReturnType<typeof useScopeTemplateApplyStepApplyToProjectMutation>;
export type ScopeTemplateApplyStepApplyToProjectMutationResult = ApolloReactCommon.MutationResult<ScopeTemplateApplyStepApplyToProjectMutation>;